module.exports = __webpack_public_path__ + "assets/img/324ca046f41a43ad3531f9e61aecaf2d.png";